import React from 'react';
import { Avatar, Box, Grid, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import ApointmentActions from './apointmentactions';
import { formatDate2, formatPrice, formatTime } from '../../../../utils/utils';

const AppointmentDetailsTab = () => {
    const { appointmentDetails } = useAppointmentDetailsContext();

    const getProfilePic = (profilePic) => {
        if (profilePic) {
            return <Avatar className='profile-pic' alt="profile_pic" src={profilePic} />;
        }

        return (
            <Avatar className='profile-pic' alt="profile_pic">
                <PersonIcon />
            </Avatar>
        );
    };

    const patientDetailsSection = () => {
        const getName = ({firstName, middleName, lastName}) => `${firstName} ${middleName} ${lastName}`;
        return (
            <Box className="appointment-section">
                <Grid container spacing={2} my={1}>
                    <Grid item xs={12} md={6}>
                        <div style={{display: 'flex', gap: '1rem'}}>
                            {getProfilePic(appointmentDetails.patientprofile.profilePic)}
                            <div className='details-data'>
                                <Typography variant="h5" gutterBottom>
                                    <b>Patient:&nbsp;</b>{appointmentDetails.name}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Email:&nbsp;</b>{appointmentDetails.email}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Mobile:&nbsp;</b>{appointmentDetails.mobile}
                                </Typography>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div style={{display: 'flex', gap: '1rem'}}>
                            {getProfilePic(appointmentDetails.doctorprofile.profilePic)}
                            <div className='details-data'>
                                <Typography variant="h5" gutterBottom>
                                    <b>Doctor:&nbsp;</b>{getName(appointmentDetails.doctorprofile)}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Department:&nbsp;</b>{appointmentDetails.doctorprofile.department.name}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Clinic:&nbsp;</b>{appointmentDetails.doctorprofile.serviceName}
                                </Typography>
                                {/* <Typography variant="subtitle1" gutterBottom>
                                    <b>Address:&nbsp;</b>{appointmentDetails.doctoravailibility.address}
                                </Typography> */}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        );
    };
    // const doctorDetailsSection = (
    //     <>Doctor Details Section</>
    // );
    const appointmentDetailsSection = () => {
        const getApptType = ({appointmentType}) => appointmentType === 1 ? 'Personal Visit' : 'Tele Consultation';
        const getStatus = ({status}) => {
            switch (status) {
                case 'PENDING':
                    return (
                        <Typography variant='subtitle1'>
                            <b>Status:&nbsp;</b><span style={{ color: '#ed6c02', fontWeight: 600 }}>{status}</span>
                        </Typography>
                    );
                case 'CONFIRMED':
                    return (
                        <Typography variant='subtitle1'>
                            <b>Status:&nbsp;</b><span style={{ color: 'green', fontWeight: 600 }}>{status}</span>
                        </Typography>
                    );
                case 'CANCELLED':
                    return (
                        <Typography variant='subtitle1'>
                            <b>Status:&nbsp;</b><span style={{ color: 'red', fontWeight: 600 }}>{status}</span>
                        </Typography>
                    );
                case 'COMPLETED':
                    return (
                        <Typography variant='subtitle1'>
                            <b>Status:&nbsp;</b><span style={{ color: 'blue', fontWeight: 600 }}>{status}</span>
                        </Typography>
                    );
                default:
                    return (
                        <Typography variant='subtitle1'>
                            <b>Status:&nbsp;</b><span style={{ color: 'gray', fontWeight: 600 }}>{status}</span>
                        </Typography>
                    );
            }
        };
        return (
            <Box className="appointment-section">
                <Grid container spacing={2} my={1}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Appointment Address:&nbsp;</b>{appointmentDetails.doctoravailibility.address}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Appointment Type:&nbsp;</b>{getApptType(appointmentDetails)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Description:&nbsp;</b>{appointmentDetails.description}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Appointment Date:&nbsp;</b>{formatDate2(appointmentDetails.apptdatetime)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Appointment Time:&nbsp;</b>{formatTime(appointmentDetails.apptdatetime)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Booking Date:&nbsp;</b>{formatDate2(appointmentDetails.createdAt)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Booking Time:&nbsp;</b>{formatTime(appointmentDetails.createdAt)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Amount:&nbsp;</b>{formatPrice(appointmentDetails.amount)}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Payment Status:&nbsp;</b>{appointmentDetails.paymentStatus}
                        </Typography>
                        {getStatus(appointmentDetails)}
                    </Grid>
                    <Grid item xs={12} md={6} style={{alignSelf: 'flex-end'}}>
                        <ApointmentActions />
                    </Grid>
                </Grid>
            </Box>
        );
    };

    return (
        <div className='appointment-details-tab'>
            {patientDetailsSection()}
            {appointmentDetailsSection()}
        </div>
    );
};

export default AppointmentDetailsTab;